"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DROPDOWN_LABEL = exports.DROPDOWN_VALUE = exports.DROPDOWN_OPTION = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var sharedOptionProps = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  justifyContent: "flex-start",
  boxSizing: "border-box"
},
    DROPDOWN_OPTION = (0, _cxs["default"])(_objectSpread(_objectSpread({}, sharedOptionProps), {}, {
  padding: "10px 20px",
  cursor: "pointer",
  position: "relative",
  minHeight: "45px",
  ":hover:after": {
    content: "\"\"",
    background: _vars.COLOURS.cyan.jungleGreen.monkeyLight,
    position: "absolute",
    left: "10px",
    top: "5px",
    width: "calc(100% - 20px)",
    height: "calc(100% - 10px)",
    zIndex: -1,
    borderRadius: "8px"
  }
}));
exports.DROPDOWN_OPTION = DROPDOWN_OPTION;
var DROPDOWN_VALUE = (0, _cxs["default"])(sharedOptionProps);
exports.DROPDOWN_VALUE = DROPDOWN_VALUE;
var DROPDOWN_LABEL = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center",
  " >:first-child:not(:only-child)": {
    marginRight: "10px"
  }
});
exports.DROPDOWN_LABEL = DROPDOWN_LABEL;